import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './navbarlog.css';

const images = [
  { src: '/images/dashboard/favicon.jpg', alt: 'logo mwgtd', route: '/company-description' },
  { src: '/images/dashboard/news.png', alt: 'news', route: '/News' },
  { src: '/images/dashboard/1.png', alt: 'unlimitedbonusLocal' },
  { src: '/images/dashboard/2.png', alt: 'unlimitedbonusLocal' },
  { src: '/images/dashboard/ulimitedBonusInterna.png', alt: 'unlimitedbonusInter' },
  { src: '/images/dashboard/appleforyou.PNG', alt: 'appleforyou' },
  { src: '/images/dashboard/yout.png', alt: 'youtube', link: 'https://www.youtube.com/@MWGTD' },
  { src: '/images/dashboard/fb.png', alt: 'fb', link: 'https://www.facebook.com/MWGTD' },
  { src: '/images/dashboard/insta.png', alt: 'insta', link: 'https://www.instagram.com/mwg__2018?igsh=MXN5aWxyN3dweXpneg%3D%3D&utm_source=qr' },
  { src: '/images/dashboard/threads.png', alt: 'snap', link: 'https://www.threads.com/@mwg__2018?igshid=NTc4MTIwNjQ2YQ==' },
  { src: '/images/dashboard/tiktok.png', alt: 'tiktok', link: 'https://www.tiktok.com/@mwg.td?_t=ZM-8xML8yN4vBe&_r=1' },
  { src: '/images/dashboard/linkedin.png', alt: 'linkedin', link: 'https://www.tiktok.com/@mwg.td?_t=ZM-8xML8yN4vBe&_r=1' },
  { src: '/images/dashboard/whatsapp.png', alt: 'whatsapp', link: 'https://www.tiktok.com/@mwg.td?_t=ZM-8xML8yN4vBe&_r=1' },
  { src: '/images/dashboard/X.png', alt: 'X', link: 'https://x.com/mwgtd201822?s=21' },
  { src: '/images/dashboard/telegram.png', alt: 'telegram', link: 'https://t.me/Smwgtd' },
  { src: '/images/dashboard/facilityvip.png', alt: 'facilitevip' },
  { src: '/images/dashboard/cashback.PNG', alt: 'cashback' },
  { src: '/images/dashboard/buywin.png', alt: 'buywin' },
  { src: '/images/dashboard/repereservice.PNG', alt: 'repereservice' },
  { src: '/images/dashboard/thejockerchallenge.PNG', alt: 'thejockerchallenge' },
  { src: '/images/dashboard/ludochampionleage.PNG', alt: 'ludochampionleage' },
  { src: '/images/dashboard/mwgtdefootball.PNG', alt: 'jocker' },
  { src: '/images/dashboard/wiwitechnology.png', alt: 'wiwitechnology' },
  { src: '/images/dashboard/wallets.png', alt: 'wallets' },
  { src: '/images/dashboard/marketplace.png', alt: 'marketplace' },
  { src: '/images/dashboard/mytacks.png', alt: 'mytacks' },
  { src: '/images/dashboard/mypayement.png', alt: 'mypayement' },
  { src: '/images/dashboard/myorder.png', alt: 'myorder' },
  { src: '/images/dashboard/event.png', alt: 'event' },
    { src: '/images/dashboard/painting.png', alt: 'painting' },
    { src: '/images/dashboard/virtuelworld.png', alt: 'virtuelworld' },
  { src: '/images/dashboard/protectionclient.png', alt: 'protectionclient' },
  { src: '/images/dashboard/giftmax.png', alt: 'giftpro' },
  { src: '/images/dashboard/ultragift.png', alt: 'ultragift' },
  { src: '/images/dashboard/music.png', alt: 'music' },
  { src: '/images/dashboard/brodcast.png', alt: 'brodcast' },
  { src: '/images/dashboard/gaming.PNG', alt: 'gaming' },

];

const AUTO_SPEED = 0.5;       // pixels par frame
const DRAG_RESET_DELAY = 700; // ms avant que le défilement auto reprenne après un drag
const CLICK_THRESHOLD = 6;    // px : en dessous = clic, au dessus = drag

const NavbarLog = () => {
  const navigate = useNavigate();
  const wrapRef = useRef(null);
  const trackRef = useRef(null);

  const state = useRef({
    x: 0,
    setWidth: 0, // période exacte de la boucle = N × (largeur item + gap)
    paused: false,
    dragging: false,
    lastX: 0,
    startX: 0,
    moved: 0,
    resumeAt: 0,
  });

  // Calcule la période EXACTE de la boucle à partir des styles CSS (valeurs décimales,
  // indépendantes du zoom, du padding de la piste et du survol/scale d'un item).
  useEffect(() => {
    const track = trackRef.current;
    const measure = () => {
      const first = track.firstElementChild;
      if (!first) return;
      const itemW = parseFloat(getComputedStyle(first).width) || 0;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      state.current.setWidth = images.length * (itemW + gap);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(track);
    window.addEventListener('resize', measure);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, []);

  // boucle d'animation + drag
  useEffect(() => {
    const s = state.current;
    const wrap = wrapRef.current;
    const track = trackRef.current;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let raf;

    const tick = (now) => {
      const autoAllowed = !s.dragging && !s.paused && !reduceMotion && now > s.resumeAt;
      if (autoAllowed) {
        s.x -= AUTO_SPEED;
      }
      if (s.setWidth > 0) {
        if (s.x <= -s.setWidth) s.x += s.setWidth;
        if (s.x > 0) s.x -= s.setWidth;
      }
      track.style.transform = `translate3d(${s.x}px,0,0)`;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    const onDown = (e) => {
      s.dragging = true;
      s.startX = s.lastX = e.clientX;
      s.moved = 0;
    };
    const onMove = (e) => {
      if (!s.dragging) return;
      const dx = e.clientX - s.lastX;
      s.lastX = e.clientX;
      s.moved = Math.abs(e.clientX - s.startX);
      s.x += dx;
    };
    const onUp = () => {
      if (!s.dragging) return;
      s.dragging = false;
      s.resumeAt = performance.now() + DRAG_RESET_DELAY;
    };
    const onEnter = () => (s.paused = true);
    const onLeave = () => (s.paused = false);

    track.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    wrap.addEventListener('mouseenter', onEnter);
    wrap.addEventListener('mouseleave', onLeave);

    return () => {
      cancelAnimationFrame(raf);
      track.removeEventListener('pointerdown', onDown);
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      wrap.removeEventListener('mouseenter', onEnter);
      wrap.removeEventListener('mouseleave', onLeave);
    };
  }, []);

  const handleImageClick = (image) => {
    if (state.current.moved > CLICK_THRESHOLD) return; // c'était un drag, pas un clic
    if (image.route) {
      navigate(image.route);
    } else if (image.link) {
      window.open(image.link.trim(), '_blank', 'noopener,noreferrer');
    }
  };

  // `duplicate` = copie décorative pour la boucle infinie
  const renderSet = (duplicate) =>
    images.map((image, index) => {
      const clickable = image.route || image.link;
      return (
        <div
          key={(duplicate ? 'dup-' : 'main-') + index}
          className="marquee-item"
          style={{ cursor: clickable ? 'pointer' : 'default' }}
          onClick={() => handleImageClick(image)}
          onKeyDown={(e) => e.key === 'Enter' && handleImageClick(image)}
          tabIndex={clickable && !duplicate ? 0 : -1}
          role={clickable ? 'button' : undefined}
          aria-hidden={duplicate ? true : undefined}
        >
          <img
            src={image.src}
            alt={duplicate ? '' : image.alt}
            className="nav-img"
            loading="eager"
            decoding="async"
            draggable={false}
          />
        </div>
      );
    });

  return (
    <nav className="navbarlog" role="navigation" aria-label="Main navigation">
      <div className="marquee-wrap" ref={wrapRef}>
        <div className="marquee-track" ref={trackRef}>
          {renderSet(false)}
          {renderSet(true)}
        </div>
      </div>
    </nav>
  );
};

export default NavbarLog;